import "./css/reset.css"
import "./css/colors.css"
import "./css/layout.css"
import "./css/plugins.css"
import "./css/typography.css"
import "./css/utils.css"
import "./css/grid.css"
import "./css/icons.css"
import "./css/buttons.css"
import "./css/forms.css"
import "./css/header.css"
import "./css/footer.css"
import "./css/hero.css"
import "./css/details.css"
import "./css/masonry.css"
import "./css/elements.css"

import "./css/engagement-submenu.css"
import "./css/arguments.css"
import "./css/faq.css"
import "./css/articles.css"
import "./css/events.css"
import "./css/testimonials.css"
import "./css/croppie.css"
import "./css/donate.css"
import "./css/cards.css"
import "./css/shop.css"
import "./css/cookiecontrol.css"
import "./css/gallery.css"
import "./css/pledge.css"
import "./css/committees.css"
import "./css/supporters.css"

import "./css/admin.css"
import "./css/variables.css"

import "./fonts/roboto-var/roboto-var.css"

import { initArguments } from "./js/components/arguments"
import { initFAQ } from "./js/components/faq"
import { initFormHelpers } from "./js/components/formHelpers"
import { initHero } from "./js/components/hero"
import { initNav } from "./js/components/nav"
import { initNewsletterForm } from "./js/components/newsletterForm"
import { initPledgeProgressBar } from "./js/components/pledge"
import { initSharingMenu } from "./js/components/sharingMenu"
import { initShopProductScroll } from "./js/components/shop"
import { initTestimonials } from "./js/components/testimonials"
import { initMasonry } from "./js/lib/masonry"
import { onReady, qs, qsa } from "./js/utils/dom"
// Plausible is switched off for this campaign -- see js/utils/plausible.js.
// import { initPlausibleForLanguageSites } from "./js/utils/plausible"
import { initScrollDetection } from "./js/utils/scroll"

window.htmx = require("htmx.org")

onReady(initNav)
onReady(initArguments)
onReady(initTestimonials, true)
onReady(initSharingMenu)
onReady(initFAQ)
onReady(initHero)
onReady(initMasonry)
onReady(initNewsletterForm)
onReady(initShopProductScroll)
onReady(initScrollDetection)
// onReady(initPlausibleForLanguageSites)
onReady(initFormHelpers)
onReady(initPledgeProgressBar)

onReady(async () => {
  const galleries = qsa(".swiper")
  if (galleries.length) {
    const { renderGallery } = await import(
      /* webpackPrefetch: true */ "./js/components/gallery"
    )
    galleries.forEach(renderGallery)
  }
})

onReady(async () => {
  const form = qs("#testimonial-create")

  if (form) {
    const { initTestimonialForm } = await import(
      "./js/components/testimonialImageGenerator"
    )
    initTestimonialForm(form)

    const { initPreparedStatements } = await import(
      "./js/components/preparedStatements"
    )
    initPreparedStatements(form)

    const { initCreateSupportingCommitteeMember } = await import(
      "./js/components/create_supporting_committee_member"
    )
    initCreateSupportingCommitteeMember(form)
  }
})

const cl = document.documentElement.classList
cl.remove("no-js")
cl.add("js")
